import useSWR from "swr";
import { useCreateHeyLightAdminAxiosInstance } from "../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { BusinessType } from "../MoneyTransfer/BusinessType.tsx";

export type BusinessInformationDTO = {
  businessName: string;
  businessAddress: {
    street: string;
    postalCode: string;
    city: string;
    province: string;
  };
  vatCode: string;
  sdiCode?: string;
  pec?: string;
  businessType: BusinessType;
  taxCode?: string;
};

export function useHeyLightOrderBusinessInfoById(orderId: string) {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const { data, isLoading } = useSWR(
    `/order/invoice/${orderId}`,
    async (url) => {
      const axiosInstance = createAxiosInstance();
      const { data } = await axiosInstance.get<BusinessInformationDTO>(url);
      return data;
    },
  );

  return {
    businessInformation: data,
    isLoading,
  };
}
